export default "__VITE_ASSET__xa3W1Nh7__"